
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/directorio",
      function () {
        return require("private-next-pages/directorio.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/directorio"])
      });
    }
  